import { render, staticRenderFns } from "./SkeletonLoadingNavBar.vue?vue&type=template&id=f2c07b1a&"
import script from "./SkeletonLoadingNavBar.vue?vue&type=script&lang=js&"
export * from "./SkeletonLoadingNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports